<template>
  <div class="wrap">
    <Modal
      v-model="purviewCountModal"
      title="客户权限统计"
      width="1000"
      footer-hide
    >
      <div class="search-bar">
        <div class="search-sales">
          <Input
            v-model="searchCountText"
            search
            placeholder="搜索用户..."
            @on-change="searchCountDevelop"
            clearable
            icon="ios-search"
            style="width: 250px; margin: 0 30px 20px 0"
          >
          </Input>
        </div>
      </div>
      <Table
        :loading="tableLoading"
        :columns="columns"
        :data="tableDate"
        border
        height="650px"
      ></Table>
    </Modal>
    <div class="header">
      <!-- 筛选区域 -->
      <div class="search-bar">
        <div class="search-sales">
          <div>业务员</div>
          <Select
            v-model="selectedUser"
            clearable
            filterable
            @on-change="choseUser"
            @on-query-change="filterUserList"
            placeholder="开发人员筛选"
          >
            <Option
              v-for="item in userList"
              :value="item._id"
              :key="item._id"
              >{{ item.name }}</Option
            >
          </Select>
        </div>
        <div class="search-customer">
          <div>客户</div>
          <Input
            v-model="searchCustomer"
            placeholder="搜索客户..."
            @on-change="searchCustomerMethod"
            clearable
            :disabled="disabled"
          >
          </Input>
        </div>
        <div class="search-department">
          <div>部门</div>
          <Select
            v-model="selectedDepartment"
            clearable
            filterable
            multiple
            @on-change="chooseDepartment"
            placeholder="部门筛选"
            :disabled="disabled"
          >
            <Option
              v-for="item in departmentList"
              :value="item._id"
              :key="item._id"
              >{{ item.name }}</Option
            >
          </Select>
        </div>
        <div class="search-area">
          <div>地区</div>
          <!-- 城市筛选 -->
          <Cascader
            :data="pca"
            placeholder="城市筛选"
            @on-visible-change="showCity"
            :render-format="citySelect"
            change-on-select
            style="width: 280px"
            :disabled="disabled"
          ></Cascader>
        </div>
        <div class="search-area" style="margin-top: 20px">
          <Checkbox
            v-model="isSupplying"
            @on-change="changSupplying"
            :disabled="disabled"
            >正在供货</Checkbox
          >
        </div>
        <div>
          <Icon
            type="md-sync"
            size="24"
            style="margin-top: 20px; cursor: pointer"
            @click="reload"
          />
        </div>
      </div>
      <!-- 按钮 -->
      <div class="header-but">
        <div class="purview-count">
          <Button type="primary" @click="openPurviewCountModal"
            >客户权限统计</Button
          >
        </div>
      </div>
    </div>
    <div class="content-wrap">
      <!-- 客户区域 -->
      <div class="customer-list">
        <div class="dev-list-wrap list-wrap">
          <div class="page-wrap">
            <div class="page-left">
              <h3 class="list-title">开发客户</h3>
              <div class="totle">
                共{{ devSalesTotal ? devSalesTotal : 0 }}个
              </div>
            </div>
            <div class="page-right">
              <Page
                :total="devSalesTotal"
                show-total
                simple
                :page-size="30"
                @on-change="devListPage"
              />
            </div>
          </div>
          <div class="dev-list list">
            <div v-if="devSalesList.length <= 0">-</div>
            <div v-else>
              <div
                class="dev-item customer-item"
                v-for="(item, index) in devSalesList"
                :value="item._id"
                :key="item._id"
              >
                <div class="dev-name list-name">{{ item.name }}</div>
                <Icon
                  type="ios-remove"
                  size="24"
                  style="
                    margin-left: 12px;
                    vertical-align: bottom;
                    cursor: pointer;
                    color: #ef0018;
                  "
                  class="remove-icon"
                  @click="removeCustomer(item, 'devSales')"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="maintain-list-wrap list-wrap">
          <div class="page-wrap">
            <div class="page-left">
              <h3 class="list-title">维护客户</h3>
              <div class="totle">
                共{{ maintainSalesTotal ? maintainSalesTotal : 0 }}个
              </div>
            </div>
            <div class="page-right">
              <Page
                :total="maintainSalesTotal"
                show-total
                simple
                :page-size="30"
                @on-change="maintainListPage"
              />
            </div>
          </div>
          <div class="maintain-list list">
            <div v-if="maintainSalesList.length <= 0">-</div>
            <div v-else>
              <div
                class="maintain-item customer-item"
                v-for="(item, index) in maintainSalesList"
                :value="item._id"
                :key="item._id"
              >
                <div class="dev-name">
                  {{ item.name }}
                </div>
                <Icon
                  type="ios-remove"
                  size="24"
                  style="
                    margin-left: 12px;
                    vertical-align: bottom;
                    cursor: pointer;
                    color: #ef0018;
                  "
                  @click="removeCustomer(item, 'maintainSales')"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="payback-list-wrap list-wrap">
          <div class="page-wrap">
            <div class="page-left">
              <h3 class="list-title">回款客户</h3>
              <div class="totle">
                共{{ paymentSalesTotal ? paymentSalesTotal : 0 }}个
              </div>
            </div>
            <div class="page-right">
              <Page
                :total="paymentSalesTotal"
                show-total
                :page-size="30"
                simple
                @on-change="paymentListPage"
              />
            </div>
          </div>
          <div class="payback-list list">
            <div v-if="paymentSalesList.length <= 0">-</div>
            <div v-else>
              <div
                class="payback-item customer-item"
                v-for="(item, index) in paymentSalesList"
                :value="item._id"
                :key="item._id"
              >
                <div class="dev-name">
                  {{ item.name }}
                </div>
                <Icon
                  type="ios-remove"
                  size="24"
                  style="
                    margin-left: 12px;
                    vertical-align: bottom;
                    cursor: pointer;
                    color: #ef0018;
                  "
                  @click="removeCustomer(item, 'paymentSales')"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="salesVisible-list-wrap list-wrap">
          <div class="page-wrap">
            <div class="page-left">
              <h3 class="list-title">销售可见客户</h3>
              <div class="totle">
                共{{ salesVisibleMemberTotal ? salesVisibleMemberTotal : 0 }}个
              </div>
            </div>
            <div class="page-right">
              <Page
                :total="salesVisibleMemberTotal"
                show-total
                :page-size="30"
                simple
                @on-change="salesVisibleMemberListPage"
              />
            </div>
          </div>
          <div class="salesVisible-list list">
            <div v-if="salesVisibleMemberList.length <= 0">-</div>
            <div v-else>
              <div
                class="salesVisible-item customer-item"
                v-for="(item, index) in salesVisibleMemberList"
                :value="item._id"
                :key="item._id"
              >
                <div class="dev-name">
                  {{ item.name }}
                </div>
                <Icon
                  type="ios-remove"
                  size="24"
                  style="
                    margin-left: 12px;
                    vertical-align: bottom;
                    cursor: pointer;
                    color: #ef0018;
                  "
                  @click="removeCustomer(item, 'salesVisibleMember')"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="techVisible-list-wrap list-wrap">
          <div class="page-wrap">
            <div class="page-left">
              <h3 class="list-title">技术可见客户</h3>
              <div class="totle">
                共{{ techVisibleMemberTotal ? techVisibleMemberTotal : 0 }}个
              </div>
            </div>
            <div class="page-right">
              <Page
                :total="techVisibleMemberTotal"
                show-total
                :page-size="30"
                simple
                @on-change="techVisibleMemberListPage"
              />
            </div>
          </div>
          <div class="techVisible-list list">
            <div v-if="techVisibleMemberList.length <= 0">-</div>
            <div v-else>
              <div
                class="techVisible-item customer-item"
                v-for="(item, index) in techVisibleMemberList"
                :value="item._id"
                :key="item._id"
              >
                <div class="dev-name">
                  {{ item.name }}
                </div>
                <Icon
                  type="ios-remove"
                  size="24"
                  style="
                    margin-left: 12px;
                    vertical-align: bottom;
                    cursor: pointer;
                    color: #ef0018;
                  "
                  @click="removeCustomer(item, 'techVisibleMember')"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 操作区域 -->
      <div class="operating-wrap">
        <div class="opera-content">
          <div class="opera-head">
            <h3 class="opera-title">客户选择器</h3>
            <div class="page-wrap">
              <div class="opera-totle">
                共{{ operaCustomerTotal ? operaCustomerTotal : 0 }}个
              </div>
              <Page
                :total="operaCustomerTotal"
                :page-size="30"
                @on-change="operaListPage"
                show-total
                simple
              />
            </div>
          </div>
          <div class="opera-select">
            <div class="select-item">
              <CheckboxGroup class="checkbox" v-model="operaQuery.check">
                <Checkbox label="devSales" :disabled="disabled">
                  <span>开发业务员</span>
                </Checkbox>
                <Checkbox label="maintainSales" :disabled="disabled">
                  <span>维护业务员</span>
                </Checkbox>
                <Checkbox label="paymentSales" :disabled="disabled">
                  <span>回款业务员</span>
                </Checkbox>
                <Checkbox
                  label="salesVisibleMember"
                  style="margin-right: 22px"
                  :disabled="disabled"
                >
                  <span>销售可见</span>
                </Checkbox>
                <Checkbox label="techVisibleMember" :disabled="disabled">
                  <span>技术可见</span>
                </Checkbox>
              </CheckboxGroup>
            </div>
            <div class="select-button" style="margin-bottom: 8px">
              <Button
                type="primary"
                ghost
                @click="operaAll('add')"
                :disabled="disabled"
                >全部添加</Button
              >
              <Button
                type="error"
                ghost
                @click="operaAll('remove')"
                :disabled="disabled"
                >全部移除</Button
              >
            </div>
          </div>
          <div class="opera-list">
            <div v-if="operaCustomerList.length <= 0">请选用户。。。</div>
            <div v-else>
              <div
                class="opera-list-item customer-item"
                v-for="(item, index) in operaCustomerList"
                :value="item._id"
                :key="item._id"
              >
                <div class="dev-name">
                  {{ item.name }}
                </div>
                <div class="opera-item">
                  <div class="add">
                    <Icon
                      type="ios-add"
                      size="28"
                      style="
                        margin-left: 12px;
                        vertical-align: bottom;
                        cursor: pointer;
                        color: #0089ff;
                      "
                      @click="updateMember('add', item)"
                    />
                  </div>
                  <div class="remove">
                    <Icon
                      type="ios-remove"
                      size="28"
                      style="
                        margin-left: 12px;
                        vertical-align: bottom;
                        cursor: pointer;
                        color: #ef0018;
                      "
                      @click="updateMember('remove', item)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { CityList } from "../../utils/pca.js";
import _ from "lodash";

const checkedToList = {
  devSales: "devSalesList",
  maintainSales: "maintainSalesList",
  paymentSales: "paymentSalesList",
  salesVisibleMember: "salesVisibleMemberList",
  techVisibleMember: "techVisibleMemberList",
};
const checkedToTotal = {
  devSales: "devSalesTotal",
  maintainSales: "maintainSalesTotal",
  paymentSales: "paymentSalesTotal",
  salesVisibleMember: "salesVisibleMemberTotal",
  techVisibleMember: "techVisibleMemberTotal",
};

export default {
  name: "CustomerPermissions",
  data() {
    return {
      page: 0,
      userList: [],
      departmentList: [],
      currentUser: null,
      selectedUser: null,
      searchCustomer: null,
      selectedDepartment: null,
      isSupplying: false,
      filterQuery: { limit: 30 },
      operaQuery: { check: [] },
      countQuery: {},
      devSalesList: [],
      devSalesTotal: null,
      devSalesPage: 0,
      maintainSalesList: [],
      maintainSalesTotal: null,
      maintainSalesPage: 0,
      paymentSalesList: [],
      paymentSalesTotal: null,
      paymentSalesPage: 0,
      salesVisibleMemberList: [],
      salesVisibleMemberTotal: null,
      salesVisibleMemberPage: 0,
      techVisibleMemberList: [],
      techVisibleMemberTotal: null,
      techVisibleMemberPage: 0,
      operaCustomerList: [],
      operaCustomerTotal: null,
      operaCustomerPage: 0,
      disabled: true,
      pca: [],
      purviewCountModal: false,
      tableLoading: false,
      searchCountText: null,
      columns: [
        {
          title: "用户",
          key: "user",
          align: "left",
          render: (h, params) => h("span", params.row.name),
        },
        {
          title: "开发业务员",
          key: "user",
          align: "right",
          render: (h, params) => h("span", params.row.rolesCount.devSales),
        },
        {
          title: "维护业务员",
          key: "user",
          align: "right",
          render: (h, params) => h("span", params.row.rolesCount.maintainSales),
        },
        {
          title: "回款业务员",
          key: "user",
          align: "right",
          render: (h, params) => h("span", params.row.rolesCount.paymentSales),
        },
        {
          title: "销售可见",
          key: "user",
          align: "right",
          render: (h, params) =>
            h("span", params.row.rolesCount.salesVisibleMember),
        },
        {
          title: "技术可见",
          key: "user",
          align: "right",
          render: (h, params) =>
            h("span", params.row.rolesCount.techVisibleMember),
        },
      ],
    };
  },
  mounted() {
    this.getUserList();
    this.getDepartmentListMethod();
  },
  computed: {
    ...mapState({
      tableDate: (state) => state.customer.userCustomerRolesCount,
    }),
  },
  methods: {
    ...mapActions({
      getUsersList: "user/getUsersAction",
      getCustomers: "customer/getCustomerSimpleListAction",
      updateManyCustomer: "customer/updateManyCustomerAction",
      getUserCustomerRolesCount: "customer/getUserCustomerRolesCountAction",
      getDepartmentList: "department/getDepartmentListAction",
    }),
    // 获取用户列表
    async getUserList() {
      try {
        const data = await this.getUsersList();
        this.userList = data.userList;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
      }
    },
    // 搜索用户
    async filterUserList(name) {
      try {
        const data = await this.getUsersList({ userName: name });

        this.userList = data.userList;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
      }
    },
    // 选中开发人员
    async choseUser(user) {
      if (user) {
        this.currentUser = user;
        this.disabled = false;
        this.getCustomerMethod();
      } else {
        this.devSalesList = [];
        this.devSalesTotal = null;
        this.maintainSalesList = [];
        this.maintainSalesTotal = null;
        this.paymentSalesList = [];
        this.paymentSalesTotal = null;
        this.salesVisibleMemberList = [];
        this.salesVisibleMemberTotal = null;
        this.techVisibleMemberList = [];
        this.techVisibleMemberTotal = null;
        this.operaCustomerList = [];
        this.operaCustomerTotal = null;
        this.currentUser = null;
        this.disabled = true;
      }
    },
    // 获取所有客户列表的方法
    getCustomerMethod(page) {
      this.filterQuery = {
        ...this.filterQuery,
      };
      const user = this.currentUser;
      const devSalesList = this.getCustomers({
        ...this.filterQuery,
        devSales: user,
        skip: this.devSalesPage * 30,
      });
      const maintainSalesList = this.getCustomers({
        ...this.filterQuery,
        maintainSales: user,
        skip: this.maintainSalesPage * 30,
      });
      const paymentSalesList = this.getCustomers({
        ...this.filterQuery,
        paymentSales: user,
        skip: this.paymentSalesPage * 30,
      });
      const salesVisibleMemberList = this.getCustomers({
        ...this.filterQuery,
        salesVisibleMember: user,
        skip: this.salesVisibleMemberPage * 30,
      });
      const techVisibleMemberList = this.getCustomers({
        ...this.filterQuery,
        techVisibleMember: user,
        skip: this.techVisibleMemberPage * 30,
      });
      const operaCustomerList = this.getCustomers({
        ...this.filterQuery,
        skip: this.operaCustomerPage * 30,
      });
      Promise.all([
        devSalesList,
        maintainSalesList,
        paymentSalesList,
        salesVisibleMemberList,
        techVisibleMemberList,
        operaCustomerList,
      ]).then((res) => {
        this.devSalesList = res[0].customerList;
        this.devSalesTotal = res[0].totalCounts;
        this.maintainSalesList = res[1].customerList;
        this.maintainSalesTotal = res[1].totalCounts;
        this.paymentSalesList = res[2].customerList;
        this.paymentSalesTotal = res[2].totalCounts;
        this.salesVisibleMemberList = res[3].customerList;
        this.salesVisibleMemberTotal = res[3].totalCounts;
        this.techVisibleMemberList = res[4].customerList;
        this.techVisibleMemberTotal = res[4].totalCounts;
        this.operaCustomerList = res[5].customerList;
        this.operaCustomerTotal = res[5].totalCounts;
      });
    },
    // 搜索客户的方法
    searchCustomerMethod: _.debounce(function () {
      if (this.searchCustomer && this.searchCustomer.trim() !== "") {
        this.filterQuery.name = this.searchCustomer;
      } else {
        delete this.filterQuery.name;
      }
      this.getCustomerMethod();
    }, 1000),
    async getDepartmentListMethod() {
      try {
        const data = await this.getDepartmentList();
        this.departmentList = data;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
      }
    },
    chooseDepartment(department) {
      if (department.length > 0) {
        this.filterQuery.department = department.join(",");
      } else {
        delete this.filterQuery.department;
      }
      this.getCustomerMethod();
    },
    showCity() {
      this.pca = CityList;
    },
    // 城市选择器
    citySelect(labels) {
      if (!this.disabled) {
        if (labels && labels.length > 0) {
          [
            this.filterQuery.province,
            this.filterQuery.city,
            this.filterQuery.dist,
          ] = [labels[0].slice(0, labels[0].length - 1), labels[1], labels[2]];
        } else {
          delete this.filterQuery.province;
          delete this.filterQuery.city;
          delete this.filterQuery.dist;
        }
        this.getCustomerMethod();
        return labels.join(" ");
      }
    },
    changSupplying(e) {
      if (e) {
        this.filterQuery.isSupplying = true;
      } else {
        delete this.filterQuery.isSupplying;
      }
      this.getCustomerMethod();
    },
    // 打开权限统计窗口
    async openPurviewCountModal() {
      this.purviewCountModal = true;
      this.tableLoading = true;
      await this.getUserCustomerRolesCount();
      this.tableLoading = false;
    },
    // 搜索权限统计的用户
    async searchCountDevelop() {
      if (this.searchCountText && this.searchCountText.trim() !== "") {
        this.countQuery.name = this.searchCountText;
      } else {
        delete this.countQuery.name;
      }
      await this.getUserCustomerRolesCount(this.countQuery);
    },
    devListPage(page) {
      if (page) this.devSalesPage = page - 1;
    },
    maintainListPage(page) {
      if (page) this.maintainSalesPage = page - 1;
    },
    paymentListPage(page) {
      if (page) this.paymentSalesPage = page - 1;
    },
    salesVisibleMemberListPage(page) {
      if (page) this.salesVisibleMemberPage = page - 1;
    },
    techVisibleMemberListPage(page) {
      if (page) this.techVisibleMemberPage = page - 1;
    },
    operaListPage(page) {
      if (page) this.operaCustomerPage = page - 1;
    },
    // list移除
    async removeCustomer(item, check) {
      const data = {};
      data.conditions = { _id: item._id };
      data.updateData = { removeMemberFromField: {} };
      data.updateData.removeMemberFromField[check] = this.currentUser;
      try {
        await this.updateManyCustomer(data);
        this[checkedToList[check]].find((c, index) => {
          if (c._id === item._id) {
            return this[checkedToList[check]].splice(index, 1);
          }
        });
        this[checkedToTotal[check]] = this[checkedToTotal[check]] - 1;
        this.$Message.success("移除成功");
      } catch (error) {
        this.$Message.error("移除失败" + error);
      }
    },
    // 全部添加
    async operaAll(opera) {
      if (!this.operaQuery.check.length <= 0) {
        const data = {};
        data.conditions = _.omit(this.filterQuery, "limit");
        if (opera === "add") {
          data.updateData = { addMemberToField: {} };
          this.operaQuery.check.forEach((element) => {
            data.updateData.addMemberToField[element] = this.currentUser;
          });
        } else if (opera === "remove") {
          data.updateData = { removeMemberFromField: {} };
          this.operaQuery.check.forEach((element) => {
            data.updateData.removeMemberFromField[element] = this.currentUser;
          });
        }
        try {
          const customer = await this.updateManyCustomer(data);
          this.getCustomerMethod();
          this.$Message.success("添加成功");
        } catch (error) {
          this.$Message.error("添加失败", error);
        }
      } else {
        this.$Message.error("请先选择要添加的权限");
      }
    },
    // opera单个更新
    async updateMember(opera, item) {
      if (!this.operaQuery.check.length <= 0) {
        const data = {};
        data.conditions = { _id: item._id };
        if (opera === "add") {
          data.updateData = { addMemberToField: {} };
          this.operaQuery.check.forEach((element) => {
            data.updateData.addMemberToField[element] = this.currentUser;
          });
          this.operaQuery.check.forEach((e) => {
            const isExist = this[checkedToList[e]].some((list) => {
              return list._id === item._id;
            });
            if (!isExist) {
              this[checkedToList[e]].unshift(item);
              this[checkedToTotal[e]] = this[checkedToTotal[e]] + 1;
            }
          });
        } else if (opera === "remove") {
          data.updateData = { removeMemberFromField: {} };
          this.operaQuery.check.forEach((element) => {
            data.updateData.removeMemberFromField[element] = this.currentUser;
          });
          this.operaQuery.check.forEach((e) => {
            this[checkedToList[e]].find((c, index) => {
              if (c._id === item._id) {
                return this[checkedToList[e]].splice(index, 1);
              }
            });
            this[checkedToTotal[e]] = this[checkedToTotal[e]] - 1;
          });
        }
        try {
          await this.updateManyCustomer(data);
          this.$Message.success(`${opera === "add" ? "添加成功" : "移除成功"}`);
        } catch (error) {
          this.$Message.error(
            `${opera === "add" ? "添加失败" + error : "移除失败" + error}`
          );
        }
      } else {
        this.$Message.error("请先选择要添加的权限");
      }
    },
    // 刷新
    async reload() {
      try {
        await this.getCustomerMethod();
        this.$Message.success("刷新成功");
      } catch (error) {
        this.$$Message.error("刷新失败" + error);
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.wrap
  overflow auto

.header
  padding-bottom 20px
  border-bottom 1px solid #B6B6B6
  display flex
  justify-content space-between
  align-items center

.search-bar
  display flex
  justify-content flex-start
  align-items center

  div
    margin-right 20px

.purview-count
  margin-top 20px

.list-wrap
  margin-right 30px

.page-wrap
  display flex
  justify-content space-between
  align-items flex-end

.list
  width 250px
  height 760px
  font-size 16px
  padding 5px
  overflow-y auto
  border 1px solid lightgray

.customer-item
  display flex
  justify-content space-between

.customer-item:hover
  background-color #DDF1FF

.dev-name
  width 200px
  // overflow hidden
  // text-overflow ellipsis
  // white-space nowrap
  cursor pointer

.customer-list
  display flex
  justify-content flex-start

.content-wrap
  display flex
  justify-content space-between

.operating-wrap
  width 300px

.opera-title
  margin-right 10px

.checkbox
  display flex
  flex-wrap wrap

.checkbox > *
  margin-bottom 8px

.select-button
  display flex
  justify-content space-around

.opera-list
  height 630px
  border 2px solid #0089FF
  border-radius 5px
  padding 5px
  font-size 16px
  overflow-y auto

  .opera-list-item
    display flex
    justify-content space-between

    .opera-item
      display flex
      justify-content space-between

.opera-customer
  line-height 28px
</style>